<template>
  <div class='bindPage rightPage'>
    <div class='layout'>
      <v-search :formContent='formContent' :SearchForm='SearchForm' :inline='true' :optareBtn='optareBtn'
                :treePathObj='treePathObj' @resetFn='resetFn' @confirmFn='getListFn' @searchFn='getListFn'
                @stopFn='stopFn'
                @netFn='netFn' />
      <div class='componentPage'>
        <bindTable :tableData='tableData' v-bind='$attrs' :loading='loading' @stopUseFn='stopUseFn'
                   @choozeTable='choozeTable' @configFn='configFn' @detailFn='detailFn' />
        <Pagination class='pagination' :total='total' :page.sync='SearchForm.iDisplayStart'
                    :limit.sync='SearchForm.iDisplayLength' @pagination='getListFn'></Pagination>
      </div>
    </div>
    <!-- 网络参数 -->
    <Net :isShow.sync='isShow' :title='title' :choozeTableData='choozeTableData' ref='net' />
    <!-- 配置信息 -->
    <Config :isShowConfig.sync='isShowConfig' :title='title' :rowData='rowData' v-bind='$attrs' ref='config'
            v-if='isShowConfig' />
  </div>
</template>

<script>
import formMixin from '@/utils/formMixins.js'
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'
import qs from 'qs'
import bindTable from './bindTable.vue'
import Net from '../components/VNet.vue'
import Config from '../modal/ConfigDialog/ConfigDialog.vue'
import { gatewayList, gatewayUpdateStatus } from '@/api/modules/gateway.js'
import { deviceListCarrierPreHandle } from '@/pages/equipment/common/preHandle'
import { getPermission } from '@/utils/permission'
import { SCHEDU_SEARCH_CONFIG_STATUS } from '@/common/schedule/Search'

export default {
  mixins: [formMixin, getAllTreePath],
  components: {
    bindTable,
    Net,
    Config
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newVal) {
        this.formContent[1].selectParam = newVal
      },
      immediate: true
    }
  },
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    }
  },
  data () {
    return {
      formContent: [
        {
          id: 1,
          text: 'device.gateway_name',
          type: 'input',
          paramsName: 'name',
          isChooze: true
        },
        {
          id: 2,
          text: 'device.gateway_type',
          type: 'select',
          paramsName: 'type',
          isChooze: false,
          selectParam: []
        },
        {
          id: 5,
          text: 'device.running_status',
          type: 'select',
          paramsName: 'status',
          selectParam: [
            {
              value: '',
              icon: 'el-icon-thumb',
              label: 'public.please'
            },
            {
              value: 0,
              icon: 'iconfont icon-wu-WiFi',
              label: 'selectMsg.Offline'
            },
            {
              value: 1,
              icon: 'iconfont icon-wifi',
              label: 'selectMsg.Online'
            }
          ],
          isChooze: false
        },
        SCHEDU_SEARCH_CONFIG_STATUS,
        {
          id: 4,
          text: 'public.carrier',
          type: 'input',
          paramsName: 'carrierName',
          isChooze: false
        },
        {
          id: 3,
          text: 'device.mac_address',
          type: 'input',
          paramsName: 'mac',
          isChooze: false
        }
      ],
      SearchForm: {
        name: null,
        scopeName: this.$store.state.SchemaTree[0].sceneCode === 'all_node' ? null : this.$store.state.SchemaTree[0].label,
        type: '',
        mac: null,
        carrierName: null,
        status: '',
        configStatus: null
      },
      total: 0,
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.stop',
          method: 'stopFn'
        },
        {
          id: 2,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.net_param',
          method: 'netFn'
        }
      ],
      choozeTableData: [],
      // 网络参数
      isShow: false,
      title: '',
      // 配置信息
      isShowConfig: false,
      // 把表格的数据也传递过去
      rowData: {},
      // 详情
      isDetailShow: false,
      detailObj: {},
      // 属性的健名
      deviceType: {},
      // 属性的对应值
      deviceProperty: {},
      netObj: {}
    }
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (this.sysAdmin === 'noSysNoAdmin') {
      this.optareBtn.pop()
    }
  },
  methods: {

    /** 分页 */
    getListFn () {
      this.loading = true

      gatewayList(this.SearchForm, 'bind')
        .then(({
          result,
          pageInfo
        }) => {
          this.tableData = result.map(item => {
            // item.carrierNameArray = item.carrierName.split(',')
            // item.sceneNameArray = item.sceneName.split(',')
            item.carrierList = deviceListCarrierPreHandle(item)
            return item
          })
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    resetFn () {
      this.SearchForm = {
        name: null,
        type: null,
        mac: null,
        scopeName: this.$store.state.SchemaTree[0].sceneCode === 'all_node' ? null : this.$store.state.SchemaTree[0].label,
        carrierName: null,
        status: null,
        configStatus: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      bus.$emit('initTree')
      this.treePathObj = this.$store.state.SchemaTree[0].sceneCode === 'all_node' ? null : this.$store.state.SchemaTree[0].label
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },
    /** 多条停用 */
    stopFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      const idList = this.choozeTableData.map(item => item.id)
      const query = qs.stringify({
        ids: idList.join(','),
        status: 2
      })
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          gatewayUpdateStatus(query, 'unused').then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => {
        })
    },
    /** 单条网关停用 */
    stopUseFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const query = qs.stringify({
            ids: row.id,
            status: 2
          })
          gatewayUpdateStatus(query, 'unused').then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => {
        })
    },
    /** 网络参数弹出框 */
    netFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      this.isShow = true
      this.title = this.$t('device.add_net_param')
      this.$nextTick(() => {
        this.$refs.net.clearValidate()
      })
    },
    /** 配置 */
    configFn (row) {
      this.rowData = { ...row }
      this.rowData.url = `${row.scopeName}/${row.sceneName}/${row.carrierName}`
      this.isShowConfig = true
      this.title = $t('public.config_info')
      this.$nextTick(() => {
        this.$refs.config.activeName = 'ConfigNet'
      })
    },
    changdetail (row) {
      this.detailFn(row)
    },
    /** 详情 */
    detailFn (row) {
      bus.$emit('gatewayParam', row.id, row.name)
    }
  }
}
</script>

<style lang='scss' scoped>
.bindPage {
  width: 100%;
  padding-right: 15px;
  box-sizing: border-box;

  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
